export class QuarterlyTaxReceiptModel {
    id: number;
    uid: string;
    period: string;
    taxFormModel: string;
    taxYear: number;
    receiptNumber: string;
    receiptFile: string;
    amount: number;
    ownerId: number;
    creationDate: Date;

    image: boolean;
    pdf: boolean;
    fileUid: string;

    constructor() {
    }
}
